import { __awaiter } from 'tslib';

const ENDPOINT = 'POSTartistpromotionrequest';
function postArtistPromotionRequest(gateway, params, customURL = null, customHeaders = null, isKoussa = false) {
    return __awaiter(this, void 0, void 0, function* () {
        return gateway.post(postArtistPromotionRequest.endpoint, params, params, customURL, customHeaders, null, isKoussa);
    });
}
postArtistPromotionRequest.endpoint = ENDPOINT;

export { postArtistPromotionRequest as default };
//# sourceMappingURL=postArtistPromotionRequest.js.map
